import { Fragment } from 'react';
import Filters from '../../Products/Filters';
import {
  Dialog,
  DialogBackdrop,
  Transition,
  TransitionChild
} from '@headlessui/react';
import { XIcon } from '@heroicons/react/outline';
import { useTranslation } from 'react-i18next';
import { ICategoryFilters } from '../../../models';

export default function MobileFilters({
  show,
  close,
  filters,
  disabled
}: {
  disabled: boolean;
  show: boolean;
  close: () => void;
  filters: ICategoryFilters | undefined;
}) {
  const { t } = useTranslation();
  return (
    <Transition show={show}>
      <Dialog
        as="div"
        className="fixed inset-0 flex z-40 lg:hidden"
        onClose={close}
      >
        <TransitionChild
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <DialogBackdrop className="fixed inset-0 bg-black bg-opacity-25" />
        </TransitionChild>

        <TransitionChild
          enter="transition ease-in-out duration-300 transform"
          enterFrom="translate-x-full"
          enterTo="translate-x-0"
          leave="transition ease-in-out duration-300 transform"
          leaveFrom="translate-x-0"
          leaveTo="translate-x-full"
        >
          <div className="ml-auto relative max-w-xs w-full h-full bg-white shadow-xl py-4 pb-12 flex flex-col overflow-y-auto">
            <div className="px-4 flex items-center justify-between">
              <h2 className="text-lg font-bold text-gray-900">{t('FILTER')}</h2>
              <button
                type="button"
                className="-mr-2 w-10 h-10 bg-white p-2 rounded-md flex items-center justify-center text-gray-400"
                onClick={close}
              >
                <span className="sr-only">{t('CLOSE_MENU')}</span>
                <XIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>

            <form className="mt-4 border-t border-gray-200">
              <Filters filters={filters} mobile={true} disabled={disabled} />
            </form>
          </div>
        </TransitionChild>
      </Dialog>
    </Transition>
  );
}
